module.exports = __webpack_public_path__ + "img/Avatar-94.601b0688.svg";